// extracted by mini-css-extract-plugin
export var pillWrapper = "_yj-0";
export var showOverflow = "_yj-1";